import { HF_COMMUNITY_URL } from '@/lib/constants'
import { useFeatureFlagsStore } from '@/stores/featureFlagsStore'
import { Link } from 'react-router'

/**
 * Footer — A안 (`mockups/main-A.html` site-footer) 4 컬럼 정합.
 *
 * brand (R 마크 + 1 줄 설명) + Platform / Community / Legal 3 컬럼 +
 * bottom row (저작권 + 언어 선택). variant-c 의 단줄 `.c-footer` 대체.
 */
export function Footer() {
  const siteName = useFeatureFlagsStore((s) => s.siteName)
  return (
    <footer className="bg-nav-bg px-8 pb-8 pt-12 text-nav-text-dim" aria-label="사이트 푸터">
      <div className="mx-auto max-w-[1280px]">
        <div className="grid grid-cols-1 gap-12 border-b border-white/10 pb-8 md:grid-cols-[240px_1fr]">
          <div>
            <span
              aria-hidden="true"
              className="mb-3 grid h-7 w-7 place-items-center rounded-md text-[15px] font-black text-white"
              style={{ background: '#ff6b35' }}
            >
              K
            </span>
            <p className="m-0 mb-1.5 text-[15px] font-bold text-nav-text">{siteName}</p>
            <p className="m-0 text-[12px] leading-relaxed">
              자율성장 휴머노이드 브레인 및 개방형 AI 플랫폼
            </p>
          </div>
          <div className="grid grid-cols-1 gap-8 sm:grid-cols-3">
            <FooterColumn
              title="Platform"
              links={[
                { label: 'About', to: '/about' },
                { label: 'Docs', to: '/docs' },
                { label: 'API', to: '/docs#api' },
              ]}
            />
            <FooterColumn
              title="Community"
              links={[
                {
                  label: 'HuggingFace 조직',
                  href: HF_COMMUNITY_URL,
                  external: true,
                },
                { label: 'Discussions', to: '/community' },
                { label: 'Contact', to: '/contact' },
              ]}
            />
            <FooterColumn
              title="Legal"
              links={[
                { label: 'Terms of Service', to: '/terms' },
                { label: 'Privacy Policy', to: '/privacy' },
                { label: 'License', to: '/license' },
              ]}
            />
          </div>
        </div>
        <div className="flex items-center justify-between pt-6 text-[12px]">
          <div className="flex items-center gap-2">
            <span
              aria-hidden="true"
              className="inline-block h-2.5 w-2.5 rounded-full"
              style={{ background: '#ff6b35' }}
            />
            <span>© 2026 ETRI-KIMM. All rights reserved.</span>
          </div>
        </div>
      </div>
    </footer>
  )
}

type FooterLink =
  | { label: string; to: string; href?: undefined; external?: undefined }
  | { label: string; href: string; external?: boolean; to?: undefined }

function FooterColumn({ title, links }: { title: string; links: FooterLink[] }) {
  return (
    <div>
      <p className="mb-3 text-[11px] font-bold uppercase tracking-wider text-nav-text">{title}</p>
      {links.map((l) => {
        const cls = 'mb-2 block text-[13px] text-nav-text-dim no-underline hover:text-nav-text'
        return l.to !== undefined ? (
          <Link key={l.label} to={l.to} className={cls}>
            {l.label}
          </Link>
        ) : (
          <a
            key={l.label}
            href={l.href}
            target={l.external ? '_blank' : undefined}
            rel={l.external ? 'noopener noreferrer' : undefined}
            className={cls}
          >
            {l.label}
          </a>
        )
      })}
    </div>
  )
}
